import { router, setPageContent } from "..";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import {} from "../locale";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { delNotice, getNotices, postNotice } from "./notices_api";

/**
 * @type {import('navigo').Handler}
 */
async function loadNoticesPage(ctx) {
	const notices = await getNotices(false);

	const english = Bulma.input({
		type: "text",
	});

	const french = Bulma.input({
		type: "text",
	});

	const german = Bulma.input({
		type: "text",
	});

	const swedish = Bulma.input({
		type: "text",
	});

	const isPublic = Bulma.checkbox({
		text: "Public",
	});

	/**
	 * @param {Notice} notice
	 */
	function newNoticeRow(notice) {
		const row = Bulma.tableRow(
			{},
			Bulma.tableDataCell(notice.English),
			Bulma.tableDataCell(
				MaterialDesign.icon({
					id: notice.Public ? "visibility" : "visibility_off",
				}),
			),
			Bulma.tableDataCell(
				MaterialDesign.icon({
					id: "content_copy",
					onClick: onClickCopy,
				}),
			),
			Bulma.tableDataCell(
				MaterialDesign.icon({
					id: "close",
					onClick: onClickDelete,
				}),
			),
		);

		function onClickCopy() {
			isPublic.setChecked(notice.Public);
			english.setValue(notice.English);
			french.setValue(notice.French);
			german.setValue(notice.German);
			swedish.setValue(notice.Swedish);
		}

		function onClickDelete() {
			const attempt = errorSection.attempt(async () => {
				await delNotice(notice.Id);
				row.remove();
			});
			loadingScreen.waitFor(attempt);
		}

		return row;
	}

	setPageContent(
		centeredBox(
			"large",
			Bulma.breadcrumb(
				Html.anchor(
					{
						onClick: () => router.jump("/admin"),
					},
					"Admin",
				),
				Html.anchor({}, "Notices"),
			),
			Bulma.table({
				classList: ["is-fullwidth"],
				body: notices.map(newNoticeRow),
			}),
			document.createElement("hr"),
			Bulma.field(
				{},
				Bulma.label("English"),
				Bulma.control({}, english.element),
			),
			Bulma.field(
				{},
				Bulma.label("French"),
				Bulma.control({}, french.element),
			),
			Bulma.field(
				{},
				Bulma.label("German"),
				Bulma.control({}, german.element),
			),
			Bulma.field(
				{},
				Bulma.label("Swedish"),
				Bulma.control({}, swedish.element),
			),
			Bulma.field({}, Bulma.control({}, isPublic.element)),
			Bulma.field(
				{
					styles: ["is-grouped", "is-grouped-multiline"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickSave,
							styles: ["is-primary"],
						},
						"Save",
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickClear,
							styles: ["is-primary"],
						},
						"Clear",
					),
				),
			),
		),
	);

	async function onClickClear() {
		isPublic.setChecked(false);
		english.setValue("");
		french.setValue("");
		german.setValue("");
		swedish.setValue("");
	}

	async function onClickSave() {
		const attempt = errorSection.attempt(async () => {
			await postNotice({
				Public: isPublic.isChecked(),
				English: english.getValue(),
				French: french.getValue(),
				German: german.getValue(),
				Swedish: swedish.getValue(),
			});
			loadNoticesPage(ctx);
		});
		loadingScreen.waitFor(attempt);
	}
}

export { loadNoticesPage };
